import { socketManager } from "../socket-manager";
import { SOCKET_CHAT_EVENTS, SOCKET_NAME_SPACES } from "../socket.enum";
import { chatHub } from "../chat-hub";

const SERVER_EVENTS = [
  SOCKET_CHAT_EVENTS.MESSAGE_NEW,
  SOCKET_CHAT_EVENTS.MESSAGE_UPDATED,
  SOCKET_CHAT_EVENTS.CONVERSATION_UPDATED,
  SOCKET_CHAT_EVENTS.CONVERSATION_REMOVED,
  SOCKET_CHAT_EVENTS.READ,
  SOCKET_CHAT_EVENTS.DELIVERED,
  SOCKET_CHAT_EVENTS.PLAYED,
  SOCKET_CHAT_EVENTS.TYPING,
  SOCKET_CHAT_EVENTS.PRESENCE,
  SOCKET_CHAT_EVENTS.SCHEDULED_UPDATED,
  SOCKET_CHAT_EVENTS.SETTINGS_UPDATED,
  SOCKET_CHAT_EVENTS.REACTION_NEW,
];

/** Every `/chat` event goes through the hub, which fans it out to open views. */
export const initChatListeners = () => {
  for (const event of SERVER_EVENTS) {
    socketManager.on<unknown>(SOCKET_NAME_SPACES.CHAT, event, (payload) =>
      chatHub.dispatch(event, payload),
    );
  }
};
